Handlebars.registerHelper('rename', function(value) {
  return value.replace(/Ue/g, 'Ü').replace(/Oe/g, 'Ö').replace(/Ae/g, 'Ä');
});

Handlebars.registerHelper('if_logged_in', function(opts) {
  if (typeof window.userLoggedIn !== 'undefined') {
    if (window.userLoggedIn === true) {
      return opts.fn(this);
    } else {
      return opts.inverse(this);
    }
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_group', function(teaserParentGuid, opts) {
  if (typeof window.groupGuid !== 'undefined') {
    if (window.groupGuid === teaserParentGuid) {
      return opts.fn(this);
    } else {
      return opts.inverse(this);
    }
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_or', function(a, b, opts) {
  if (a || b) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_not_empty', function(array, opts) {
  if (array) {
    if (array.length === 1 && array[0] === '') {
      return opts.inverse(this);
    } else {
      return opts.fn(this);
    }
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_eq', function(a, b, opts) {
  if (a == b) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_not_eq', function(a, b, opts) {
  if (a != b) {
    return opts.fn(this);
  } else {
    return opts.inverse(this);
  }
});

Handlebars.registerHelper('if_filter', function(filter, opts) {
  if (typeof window.excludeFilter !== 'undefined') {
    if (filter == '' || $.inArray(filter, window.excludeFilter) != -1) {
      return opts.inverse(this);
    } else {
      return opts.fn(this);
    }
  } else {
    if (filter == '') {
      return opts.inverse(this);
    } else {
      return opts.fn(this);
    }
  }
});

Handlebars.registerHelper('if_extern', function(redirect, opts) {
  if (redirect) {
    var r = new RegExp('^(?:[a-z]+:)?//', 'i');
    
    var getLocation = function(href) {
      var l = document.createElement("a");
      l.href = href;
      return l;
    };

    var l = getLocation(redirect);

    if(!r.test(redirect) || l.hostname === window.location.hostname) {
      return opts.inverse(this);
    } else {
      return opts.fn(this);
    }
  }
  return opts.inverse(this);
});

Handlebars.registerHelper('show_path', function(link) {
  if (typeof window.envPrefixPath !== 'undefined') {
    return window.envPrefixPath + link;
  } else {
    return link;
  }
});

Handlebars.registerHelper('pdf_badge', function(url) {
  var path = url.split('.').pop();
  if (path == 'pdf') {
    return '<span class="teasercard__pdf"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="21" viewBox="0 0 18 21"><g fill="none" fill-rule="evenodd"><path fill="#BFBFBF" d="M18,19 C18,20.1045695 17.1045695,21 16,21 L2,21 C0.8954305,21 1.3527075e-16,20.1045695 0,19 L0,2 C-1.3527075e-16,0.8954305 0.8954305,2.02906125e-16 2,0 L12,0 L18,6 L18,19 Z"/><polygon fill="#909090" points="12 0 18 6 12 6"/><path fill="#FFF" fill-rule="nonzero" d="M3.66 1.72C3.66.76 2.89 0 1.93 0L.3 0C.13 0 0 .13 0 .29L0 6.82C0 6.99.13 7.12.3 7.12L.72 7.12C.89 7.12 1.02 6.99 1.02 6.82L1.02 4.88 1.93 4.88C2.89 4.88 3.66 4.11 3.66 3.16L3.66 1.72ZM2.64 3.16C2.64 3.54 2.33 3.86 1.93 3.86L1.02 3.86 1.02 1.02 1.93 1.02C2.33 1.02 2.64 1.33 2.64 1.72L2.64 3.16ZM8.36111111 1.72C8.36111111.76 7.59111111 0 6.63111111 0L5.00111111 0C4.83111111 0 4.70111111.13 4.70111111.3L4.70111111 6.82C4.70111111 6.99 4.83111111 7.12 5.00111111 7.12L6.63111111 7.12C7.59111111 7.12 8.36111111 6.34 8.36111111 5.39L8.36111111 1.72ZM7.34111111 5.39C7.34111111 5.79 7.03111111 6.1 6.63111111 6.1L5.72111111 6.1 5.72111111 1.02 6.63111111 1.02C7.03111111 1.02 7.34111111 1.33 7.34111111 1.72L7.34111111 5.39ZM10.3522222 7.12C10.5222222 7.12 10.6522222 6.99 10.6522222 6.82L10.6522222 4.07 12.7922222 4.07C12.9522222 4.07 13.0922222 3.92 13.0922222 3.76L13.0922222 3.36C13.0922222 3.18 12.9522222 3.05 12.7922222 3.05L10.6522222 3.05 10.6522222 1.02 13.0022222 1.02C13.1722222 1.02 13.3022222.89 13.3022222.72L13.3022222.3C13.3022222.13 13.1722222 0 13.0022222 0L9.93222222 0C9.76222222 0 9.63222222.13 9.63222222.3L9.63222222 6.82C9.63222222 6.99 9.76222222 7.12 9.93222222 7.12L10.3522222 7.12Z" transform="translate(2.738 8.88)"/></g></svg></span>';
  }
});

Handlebars.registerHelper('if_cleaned_string', function(content, opts) {
    var string = content.replace(/(?:[0-9a-zA-Z]])(.*)/g, '').trim();
    if (string != '' && typeof string !== 'undefined' && string.length != 0) {
      return opts.fn(this);
    } else {
      return opts.inverse(this);
    }
});

Handlebars.registerHelper('trim_string', function(opts) {

  //Wirft am Inhalte Anfang alles raus was keine Zahl oder Buchstabe ist.
  var regex = /^(?:[^0-9a-zA-ZüÜäÄöÖß"'„“\<\>]+)(.*)/;
  var string = opts.trim().match(regex);

  if (string != null && string[1] != '' && typeof string[1] !== 'undefined' && string[1] != null && string[1].length != 0) {
    return new Handlebars.SafeString(string[1]);
  } else {
    return new Handlebars.SafeString(opts);
  }
});

Handlebars.registerHelper('date_part', function(date, part) {
  const months = ["Jan", "Feb", "Mär", "Apr", "Mai", "Jun", "Jul", "Aug", "Sep", "Okt", "Nov", "Dez"];
  let datePart = date.split('.');
  if (part === 'month') {
    return months[datePart[1].replace(/^0+(?!\.|$)/, '')-1];
  } else if (part === 'year') {
    return datePart[2].slice(-2);
  } else {
    return datePart[0];
  }
});

Handlebars.registerHelper('escape', function(variable) {
  if (variable) {
    if (typeof variable === 'object') {
      return variable.toString().replace(/'/g, "\\'");
    } else {
      return variable.replace(/'/g, "\\'");
    }
  } else {
    return "";
  }
});